
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Puzzle from "../../modules/puzzle/Puzzle";
import { puzzleApi } from "../../services/api";
async function getStaticProps() {
    let puzzles;
    let nextPuzzleId = 6497;
    try {
        const response = await puzzleApi.get("/puzzles");
        puzzles = response.data.puzzles;
    }
    catch (e) {
        console.log("Error in puzzles index");
    }
    try {
        const response = await puzzleApi.get("/puzzleIds/random");
        nextPuzzleId = response.data.randomPuzzleId;
    }
    catch (e) {
        console.log("Error in random puzzle ID");
    }
    return {
        props: {
            puzzles,
            nextPuzzleId,
            index: true,
        },
        revalidate: puzzles ? 86400 : 300,
    };
}
export default Puzzle;

    async function __Next_Translate__getStaticProps__19ccec1b273__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzle/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19ccec1b273__ as getStaticProps }
  